import { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../Apiurl";
import { ARTICOLO_ASSENTE_SOLA_LETTURA } from "./permessiProdotto";

// Il contratto esistente legge il documento Mongo per codice VS, senza crearlo.
export default function useApriProdottoSolaLettura() {
  const { getAccessTokenSilently } = useAuth0();
  const [errore, setErrore] = useState("");
  const richiesta = useRef(null);

  useEffect(() => () => richiesta.current?.abort(), []);

  const apriProdotto = async (codiceVS, onFound) => {
    richiesta.current?.abort();
    const controller = new AbortController();
    richiesta.current = controller;
    setErrore("");
    if (!codiceVS || codiceVS === "NULL") {
      setErrore("Codice VS mancante: consultazione in sola lettura non disponibile.");
      return;
    }
    try {
      const token = await getAccessTokenSilently();
      if (controller.signal.aborted) return;
      const response = await fetch(
        `${apiUrl}/prodotti/prodotto/showByCodVS/${encodeURIComponent(codiceVS)}`,
        { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal },
      );
      if (response.status === 404) throw new Error(ARTICOLO_ASSENTE_SOLA_LETTURA);
      const data = await response.json();
      if (!response.ok) throw new Error(data?.message || data?.error || "Impossibile aprire l'articolo.");
      if (!Array.isArray(data)) throw new Error("Risposta articolo non valida.");
      if (controller.signal.aborted) return;
      if (!data.length) {
        setErrore(ARTICOLO_ASSENTE_SOLA_LETTURA);
        return;
      }
      onFound(data);
    } catch (error) {
      if (!controller.signal.aborted) setErrore(error.message || "Impossibile aprire l'articolo.");
    }
  };

  return { apriProdotto, errore };
}
